module.exports = "/_next/static/images/0cbb5a85f93fececc225a9cfa9917d93-incoming-call-icon.svg";